import { WohaCommonContent } from "../../../../modules/content/components/WohaCommonContent/WohaCommonContent";
import { WohaMedia } from "../../../../modules/content/components/WohaMedia/WohaMedia";
import { WohaSection } from "../../../../modules/content/components/WohaSection/WohaSection";
import type { IImageBlockProps } from "./ImageBlock.props";
export const ImageBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  image,
  parentClass,
  spacing,
}: IImageBlockProps) => {
  if (!image) return null;
  return (
    <WohaSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-8">
        <WohaCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <WohaMedia
          aspectRatio={image.aspectRatio}
          media={image.image}
          sizes="(min-width: 1200px) 1200px, 100vw"
        />
      </div>
    </WohaSection>
  );
};
ImageBlock.displayName = "Block::ImageBlock";
